import {Companies, Rosters, Superstars} from "./models.js";

function Staff() {

    // Integer
    const level = 1;
    const xp = 0;
    const age = null;
    const cost = null;
    const monthsLeftForTask = null;
    const unavailableMonths = 0;

    // Strings
    const name = null;
    const gender = 'male';
    const role = null;
    const currentTask = null;
    
    // Boolean
    const retired = false;

    // Objects
    const graphic = {};
    const taskData = {};

    // Foreign keys
    const companyId = null;
    const rosterId = null;
    const superstarObjectId = null;

    return {
        level,
        xp,
        age,
        cost,
        monthsLeftForTask,
        unavailableMonths,
        name,
        gender,
        role,
        currentTask,
        retired,
        graphic,
        taskData,
        companyId,
        rosterId,
        superstarObjectId,
    };
}

function getStaffCompany(staff) {
    return Companies.find({'$loki': staff.companyId})[0];
}

function getStaffRoster(staff) {
    return Rosters.find({'$loki': staff.rosterId})[0];
}

function setStaffSuperstarObject(staff, superstarObject) {
    staff.superstarObjectId = superstarObject.$loki;
}

function getStaffSuperstarObject(staff) {
    if (!staff.superstarObjectId) {
        return
    }
    return Superstars.find({'$loki': staff.superstarObjectId})[0];
}


export { Staff, getStaffCompany, getStaffRoster, setStaffSuperstarObject,
    getStaffSuperstarObject }
